import React, { useState } from 'react'

import { PopoverMenu } from 'conversations/components/NewChatSidebar/PopoverMenu'
import { HelpMenu } from 'conversations/components/NewChatSidebar/SidebarPopoverMenuItems/HelpMenu'
import { PreferencesMenu } from 'conversations/components/NewChatSidebar/SidebarPopoverMenuItems/PreferencesMenu'

import styles from './styles.module.css'

export const SidebarPopoverMenuItems: React.FC = () => {
  const [showPreferences, setShowPreferences] = useState(false)
  const [showHelp, setShowHelp] = useState(false)

  return (
    <div className={styles.container}>
      <PopoverMenu
        label="Preferences"
        data-ocweb-id="PreferencesOptions"
        active={showPreferences}
        setActive={setShowPreferences}
        menuContent={<PreferencesMenu setShowPreferences={setShowPreferences} />}
      />
      <PopoverMenu
        label="Help"
        data-ocweb-id="HelpOptions"
        active={showHelp}
        setActive={setShowHelp}
        menuContent={<HelpMenu />}
      />
    </div>
  )
}
